import React from "react";
import PropTypes from "prop-types";
import Block from "./block.js";
import UU5 from "uu5g04";
import "uu5g04-bricks";

import ns from "ns";

import createReactClass from "create-react-class";

const injectBlock = type => {
  let InjectBlock = createReactClass({
    //@@viewOn:mixins
    mixins: [
      UU5.Common.BaseMixin,
      UU5.Common.SectionMixin
    ],
    //@@viewOff:mixins

    //@@viewOn:statics
    statics: {
      tagName: ns.tag("Bricks.Block" + type.charAt(0).toUpperCase() + type.slice(1)),
      opt:{
        hoc: true
      }
    },
    //@@viewOff:statics

    //@@viewOn:propTypes
    propTypes: {
      content: PropTypes.oneOfType([
        PropTypes.array, PropTypes.string
      ]),
    },
    //@@viewOff:propTypes

    //@@viewOn:standardComponentLifeCycle
    //@@viewOff:standardComponentLifeCycle

    //@@viewOn:interface
    //@@viewOff:interface

    //@@viewOn:overridingMethods
    //@@viewOff:overridingMethods

    //@@viewOn:componentSpecificHelpers
    //@@viewOff:componentSpecificHelpers

    //@@viewOn:render
    render() {
      const content = this.props.content || this.props.children;
      return (
        <Block {...this.props} content={content} type={type} />
      );
    }
    //@@viewOff:render
  });

  return InjectBlock;
};

export default injectBlock;



// WEBPACK FOOTER //
// ./bricks/inject-block.js